import { axios, path } from './config';

export function getConfigurations(accountId) {
  const params = {
    account_id: accountId,
  };
  return axios.get(path.GET_WECHAT_CONFIGURATIONS, { ...params });
}
export function saveAccount({ appId, appSecret, encryptKey = '', accountId }) {
  const data = {
    app_id: appId,
    app_secret: appSecret,
    encrypt_key: encryptKey,
    account_id: accountId,
  };

  return axios.post(path.ADD_WECHAT_ACCOUNT, data);
}

export function deleteAccount({ accountId }) {
  const params = {
    account_id: accountId,
  };

  return axios.delete(path.DELETE_WECHAT_ACCOUNT, { ...params });
}
